import { CtaCard } from '@landtrustinc/design-system';
import React from 'react';

import { getSignupVariantData } from '../../config/signupVariants';
import type { SignupRequiredMessage } from '../../types';

type SignupRequiredProps = {
  msg: SignupRequiredMessage;
  onSignupClick: () => void;
};

const SignupRequired: React.FC<SignupRequiredProps> = ({ msg, onSignupClick }) => {
  const signupVariantData = getSignupVariantData(msg.variant);
  const showConfirmation = msg.showConfirmation ?? false;

  return (
    <>
      {showConfirmation ? (
        <CtaCard
          key={msg.id}
          title={signupVariantData.confirmationPrimary}
          description={signupVariantData.confirmationSecondary}
        />
      ) : (
        <CtaCard
          key={msg.id}
          title={signupVariantData.header}
          description={signupVariantData.subtext}
          ctaLabel={msg.ctaLabel ?? 'Free Sign Up'}
          onCtaClick={onSignupClick}
        />
      )}
    </>
  );
};

export default SignupRequired;
